import { APP_MODE } from '@shared/config/appMode/appMode'
import { useAppModeStore } from '@shared/config/appMode.store'
import { resolveOriginRegion } from '@shared/lib/origin/resolveOriginRegion'

import useOriginDomain from './useOriginDomain'

// UK content is shown either for users from GB or when the user came from banxe.uk
// (login_origin_domain / signup_origin_domain query params).
const useIsUk = () => {
    const appMode = useAppModeStore((s) => s.mode)
    const isWithoutCrypto = useAppModeStore((s) => s.isWithoutCrypto)
    const isUkOrigin = resolveOriginRegion(useOriginDomain()) === 'uk'

    return appMode === APP_MODE.DEFAULT && (isWithoutCrypto || isUkOrigin)
}

export default useIsUk
